
import React from 'react';

const CarUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			fill='none'
			viewBox='0 0 32 32'
		>
			<path
				fill='#2d2d2d'
				d='M27.83 14.87l-4.71-.78-2.76-4.6A.99.99 0 0019.5 9h-14a1 1 0 00-.93.63l-2 5c-.05.12-.06.24-.06.37H2.5v7c0 .55.45 1 1 1h1.05c.25 1.69 1.69 3 3.45 3 1.76 0 3.2-1.31 3.45-3h8.1c.25 1.69 1.69 3 3.45 3 1.76 0 3.2-1.31 3.45-3h2.05c.55 0 1-.45 1-1v-5.15c0-.99-.7-1.81-1.67-1.98zM6.18 11h6.32v3H4.98l1.2-3zM8 24c-.83 0-1.5-.67-1.5-1.5S7.17 21 8 21s1.5.67 1.5 1.5S8.83 24 8 24zm0-5c-1.39 0-2.58.82-3.15 2H4.5v-5h8v5h-1.35c-.57-1.18-1.76-2-3.15-2zm15 5c-.83 0-1.5-.67-1.5-1.5S22.17 21 23 21s1.5.67 1.5 1.5S23.83 24 23 24zm4.5-3h-1.35A3.49 3.49 0 0023 19c-1.39 0-2.58.82-3.15 2H14.5V11h4.43l1.8 3h-5.21v2h6.89l5.09.85V21zM27.5 30h-23v2h23v-2z'
			></path>
		</svg>
	);
};

export default CarUnderline;
